import { createBrowserRouter } from 'react-router-dom'
import App from '@/App'

// Configuration des routes avec l'API createBrowserRouter (React Router v6.4+)
export const router = createBrowserRouter([
  // ── Routes publiques ────────────────────────────────────────────────────
  {
    path: 'login',
    lazy: () => import('@/components/auth/LoginPage').then(m => ({ Component: m.default })),
  },
  {
    // Reçoit le JWT de la redirection backend (?token=...)
    path: 'auth/callback',
    lazy: () => import('@/components/auth/AuthCallback').then(m => ({ Component: m.default })),
  },

  // ── Routes protégées (guard dans App.tsx) ───────────────────────────────
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        lazy: () => import('@/components/DispatchTab').then(module => ({
          Component: module.default
        }))
      },
      {
        path: 'dispatch',
        lazy: () => import('@/components/DispatchTab').then(module => ({
          Component: module.default
        })),
        children: [
          {
            path: '*',
            lazy: () => import('@/components/DispatchTab').then(module => ({
              Component: module.default
            }))
          }
        ]
      },
      {
        path: 'stock',
        lazy: () => import('@/components/StockTab').then(module => ({
          Component: module.default
        })),
        children: [
          {
            path: ':subtab',
            lazy: () => import('@/components/StockTab').then(module => ({
              Component: module.default
            }))
          },
          {
            path: '*',
            lazy: () => import('@/components/StockTab').then(module => ({
              Component: module.default
            }))
          }
        ]
      },
      {
        path: 'accounting',
        lazy: () => import('@/components/AccountingTab').then(module => ({
          Component: module.default
        })),
        children: [
          {
            path: ':subtab',
            lazy: () => import('@/components/AccountingTab').then(module => ({
              Component: module.default
            }))
          },
          {
            path: '*',
            lazy: () => import('@/components/AccountingTab').then(module => ({
              Component: module.default
            }))
          }
        ]
      },
      {
        path: 'public-services',
        lazy: () => import('@/components/PublicServicesTab').then(module => ({
          Component: module.default
        }))
      },
      {
        path: 'hr',
        lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
          Component: module.default
        })),
        children: [
          {
            path: 'employees',
            lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
              Component: module.default
            }))
          },
          {
            path: 'contracts',
            lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
              Component: module.default
            }))
          },
          {
            path: 'recruitment',
            lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
              Component: module.default
            }))
          },
          {
            path: 'recruitment/*',
            lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
              Component: module.default
            }))
          },
          {
            path: '*',
            lazy: () => import('@/components/HumanResourcesTab/index.tsx').then(module => ({
              Component: module.default
            }))
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <App />,
    errorElement: <div>Page non trouvée</div>
  }
])

export const useAppRouter = () => ({ router })
